/**
 * Footer Component
 * Site-wide footer with branding, links, and disclaimers
 */

import { Link } from 'react-router-dom';
import { useCounties } from '../../hooks/useCounties';

export function Footer() {
  const currentYear = new Date().getFullYear();
  const { counties } = useCounties();

  return (
    <footer className="bg-neutral-900 text-neutral-300 py-12 mt-16">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          {/* About Section */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">About CalWMP</h3>
            <p className="text-sm mb-4 leading-relaxed">
              Free California waste management plan creation tool for construction projects
              complying with CalGreen 5.408 requirements.
            </p>
            <p className="text-xs text-neutral-400 italic leading-relaxed">
              CalWMP.com is an independent service provider and is not affiliated with, endorsed by,
              or connected to the State of California, any California government agency, or any local
              jurisdiction.
            </p>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/docs/calgreen-overview" className="hover:text-white transition-colors" onClick={() => window.scrollTo(0, 0)}>
                  CalGreen 5.408 Overview
                </Link>
              </li>
              <li>
                <Link to="/docs/materials-guide" className="hover:text-white transition-colors" onClick={() => window.scrollTo(0, 0)}>
                  Materials Guide
                </Link>
              </li>
              <li>
                <Link to="/docs/faq" className="hover:text-white transition-colors" onClick={() => window.scrollTo(0, 0)}>
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/docs/examples" className="hover:text-white transition-colors" onClick={() => window.scrollTo(0, 0)}>
                  Example Plans
                </Link>
              </li>
              <li>
                <Link to="/docs/glossary" className="hover:text-white transition-colors" onClick={() => window.scrollTo(0, 0)}>
                  Glossary
                </Link>
              </li>
            </ul>
          </div>

          {/* For Professionals */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">For Professionals</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/provider/request-invite" className="hover:text-white transition-colors" onClick={() => window.scrollTo(0, 0)}>
                  Provider Workspace
                </Link>
              </li>
              <li>
                <Link to="/provider/marketplace" className="hover:text-white transition-colors" onClick={() => window.scrollTo(0, 0)}>
                  Job Marketplace
                </Link>
              </li>
              <li>
                <Link to="/service-providers" className="hover:text-white transition-colors" onClick={() => window.scrollTo(0, 0)}>
                  Provider Information
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="hover:text-white transition-colors" onClick={() => window.scrollTo(0, 0)}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-white transition-colors" onClick={() => window.scrollTo(0, 0)}>
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="hover:text-white transition-colors" onClick={() => window.scrollTo(0, 0)}>
                  Disclaimer
                </Link>
              </li>
              <li>
                <Link to="/accessibility" className="hover:text-white transition-colors" onClick={() => window.scrollTo(0, 0)}>
                  Accessibility
                </Link>
              </li>
            </ul>
          </div>

          {/* County Pages */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">County Pages</h3>
            <ul className="space-y-2 text-sm">
              {counties.map((county) => (
                <li key={county.id}>
                  <Link to={`/counties/${county.id}`} className="hover:text-white transition-colors" onClick={() => window.scrollTo(0, 0)}>
                    {county.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-neutral-700 pt-6">
          <div className="text-center">
            <p className="text-sm text-neutral-500">
              {currentYear} CalWMP.com. All rights reserved.
            </p>
            <p className="text-xs text-neutral-600 mt-2">
              California Waste Management Plan System - CalGreen 5.408 Compliance Tool
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}